import { render, staticRenderFns } from "./index.vue?vue&type=template&id=382b8a8f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=382b8a8f&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=382b8a8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b8a8f",
  null
  
)

export default component.exports